import { Connection, getServiceURL, Scheme } from "@ihr-radioedit/sdk-network";
import { isNode } from "@ihr-radioedit/sdk-utils";
import qs from "qs";
import { requireAppToken, requireClientToken } from "./token";
function tokenLocator() {
    let acquiredToken = null;
    return async () => {
        if (!acquiredToken) {
            acquiredToken = await (isNode ? requireAppToken() : requireClientToken());
        }
        return acquiredToken;
    };
}
const SERVICE_ID = "auth";
const DEFAULT_LOCATOR = tokenLocator();
/**
 * Automatically add an Authorization interceptor into the request chain. By
 * default this uses the `tokenLocator` function inside of auth.
 */
export class AuthenticatedConnection extends Connection {
    constructor(config, interceptors, tokenFn = DEFAULT_LOCATOR) {
        if (!interceptors) {
            interceptors = [];
        }
        const token = tokenFn();
        interceptors = [
            ...interceptors,
            {
                onFulfilled: async (conf) => {
                    const tokenStr = await token;
                    if (token) {
                        conf.headers["Authorization"] = `Bearer ${tokenStr}`;
                    }
                    return conf;
                },
            },
        ];
        super(config, interceptors);
    }
}
/**
 * This is a Connection that makes use of the browser's cookies.
 */
export class ImplicitAuthenticationConnection extends Connection {
    constructor(config, interceptors) {
        config = { ...(config || {}), withCredentials: true };
        super(config, interceptors);
    }
}
export class AuthClient extends ImplicitAuthenticationConnection {
    static auto(baseURL) {
        baseURL = getServiceURL(SERVICE_ID, "", baseURL, Scheme.SECURE);
        return new AuthClient({ baseURL });
    }
    getMyPrincipal() {
        return this.http.get(`me`).then(resp => resp.data);
    }
    getPrincipalForToken(token) {
        return this.http
            .get(`me`, { params: { access_token: token } })
            .then(resp => resp.data);
    }
}
export class AuthSearchClient extends AuthenticatedConnection {
    static auto(baseURL) {
        baseURL = getServiceURL(SERVICE_ID, "", baseURL, Scheme.SECURE);
        return new AuthSearchClient({
            baseURL,
            paramsSerializer: params => qs.stringify(params, {
                arrayFormat: "comma",
                encode: false,
            }),
        });
    }
    search(options) {
        const params = {
            q: options.q,
            sort: options.sort,
            limit: options.limit,
            offset: options.offset,
            spec: this.createSpec(options),
        };
        return this.http
            .get("api/principals", { params })
            .then(resp => resp.data);
    }
    find(ids) {
        const params = { ids };
        return this.http
            .get("api/principals", { params })
            .then(resp => resp.data);
    }
    createSpec(options) {
        const spec = {};
        if (options.types && options.types.length) {
            spec.type = { $in: options.types };
        }
        if (options.memberships && options.memberships.length) {
            spec.observer_of = {
                $all: options.memberships.map(({ mem, cap }) => {
                    return { $elemMatch: { mem, cap: cap ? cap : { $exists: false } } };
                }),
            };
        }
        return btoa(JSON.stringify(spec));
    }
}
//# sourceMappingURL=client.js.map